import type { IconSvgObject } from './types';

const ThirdBracketIcon: IconSvgObject = [
  ["path", { d: "M18 3H18.5C19.6046 3 20.5 3.89543 20.5 5V9.33333C20.5 9.76607 20.6404 10.1871 20.9 10.5333L22 12L20.9 13.4667C20.6404 13.8129 20.5 14.2339 20.5 14.6667V19C20.5 20.1046 19.6046 21 18.5 21H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 3H5.5C4.39543 3 3.5 3.89543 3.5 5V9.33333C3.5 9.76607 3.35964 10.1871 3.1 10.5333L2 12L3.1 13.4667C3.35964 13.8129 3.5 14.2339 3.5 14.6667V19C3.5 20.1046 4.39543 21 5.5 21H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ThirdBracketIcon;
